import { render } from "./SingleQuestion.vue?vue&type=template&id=459d407d"
import script from "./SingleQuestion.vue?vue&type=script&lang=ts"
export * from "./SingleQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script